import {applyMiddleware, createStore, Store, Middleware} from 'redux';
import RootReducer from './reducer/rootReducer';
import thunkMiddleware from 'redux-thunk';
import {actionGetInitialData} from './action';
import {composeWithDevTools} from '@redux-devtools/extension';
import {initializeSession} from 'src/library';
import {getOrderInitialization} from 'src/utils';
import {defaultOrderInitialization} from './constants/orderInitialization';
import {IInitializeOrderResponse} from '@bold-commerce/checkout-frontend-library';

export function initializeStore(orderData?: IInitializeOrderResponse): Store {

    const compose = composeWithDevTools({});
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;
    const middleware: Middleware[] = [thunkMiddleware];
    const orderInitialization = orderData ? getOrderInitialization(orderData) : defaultOrderInitialization;

    const store = createStore(RootReducer, orderInitialization, composeEnhancers(
        applyMiddleware(...middleware)
    ));

    if (orderData) {
        store.dispatch(initializeSession);
        store.dispatch(actionGetInitialData(window.location.hostname));
    }

    return store;
}
